import React from 'react';
import '../App.css';

function TopBar(props) {
    return (
        <div className="top-bar">
            <img alt="" className="top-bar__avatar" src="/images/nightkeep_cover.jpg"></img>
            <h4 className="top-bar__name">Night Keepers 守夜人</h4>
        </div>
    )
}

export default TopBar;
